import ENThumbnail from "./ENThumbnail";

export default ENThumbnail;
